import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectWebsitesListItems } from "../../../../../redux/websites/selector";
import { websites } from "../../../../../redux/websites/action";
import { websiteCards } from "../../../../../redux/websiteCards/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import storePersist from "../../../../../redux/storePersist";
import { toast } from "react-toastify";

const AgencyWebsites = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const websitesItems = useSelector(selectWebsitesListItems)
  var tenantId = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.TenantId;
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const [
    updatedRowData,
    setUpdatedRowData
  ] = useState<any>([]);
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'WebSiteName', headerName: 'WebSiteName',searchField: 'WebSiteName', filter: true,
        filterType: 'text'  },
      { field: 'OUName', headerName: 'OrganizationUnit Name',searchField: 'OUName', filter: true,
        filterType: 'text'  },
      { field: 'HostingUrl', headerName: 'HostingUrl',searchField: 'HostingUrl', filter: true,
        filterType: 'text', input: true, type: 'text'  },
      { field: 'MappedDomain', headerName: 'MappedDomain',searchField: 'MappedDomain', filter: true,
        filterType: 'text',input: true, type: 'text'  },
      { field: 'DisplayOrder', headerName: 'DisplayOrder',searchField: 'DisplayOrder', filter: true,
        filterType: 'text',input: true, type: 'text'  },
        { field: 'FQDNName', headerName: 'FQDNName',searchField: 'FQDNName', filter: true,
          filterType: 'text',input: true, type: 'text'  },
      { field: 'Remarks', headerName: 'Remarks' },
      { field: 'TableUrl', headerName: 'Table URL' },
      { field: 'StorageEndpointUrl', headerName: 'Storage End point URL' },
      { field: 'CDNEndpointUrl', headerName: 'CDN End point URL' },
      { field: 'BlobFolderUrl', headerName: 'Blob Folder Url' },

    ]);
  }

  const handleSearch = (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column){
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }

    dispatch(websites.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`,entity:'cards',jsonData:{
      "Filters": [
        {
          "FieldName": "TenantId",
          "FilterOperatorId": 1,
          "FieldValue": tenantId,
          "FieldType": "number"
        }
      ],
      "PageNumber": pageData,
      "PageSize": pageSize,
      "SortField": "Id",
      "SortOrder": "desc",
      "Searches": searchCriteria,
      }}))
  }


  const handleReloadData = () => {
    dispatch(websites.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`,entity:'cards',jsonData:{
      "Filters": [
        {
          "FieldName": "TenantId",
          "FilterOperatorId": 1,
          "FieldValue": tenantId,
          "FieldType": "number"
        }
      ],
      "PageNumber": pageData,
      "PageSize": pageSize,
      "SortField": "Id",
      "SortOrder": "desc",
      }}))
  }
  const filterTypes = [{
    name: 'Text', value: "text"
  },
  {
    name: 'Number', value: "number"
  },
  {
    name: 'CheckBox', value: "checkbox"
  },
  {
    name: 'Date', value: "date"
  }
  ]
  const handleEdit = (data: any) => {
    navigate(`${data?.PlatformWebSiteId}`)
  }

  const handleInputChange = (event: any, field: any, row: any) => {
    const { value } = event.target;
    setUpdatedRowData((prevUser: any) => ({
      ...prevUser,
      [field]: value,
    }));
  };


  const handlereset = async (data: any) => {
    const { PlatformWebSiteId, StoreId, DepartmentId } = data;
    const requestData = {
      PlatformWebSiteId,
      StoreId,
      DepartmentId,
      TenantId: tenantId
    };
    await dispatch(websites.resetAction({ actionType: 'update' }))
    await dispatch(websites.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/sync-website-with-platform-website-template`, entity: 'websites', jsonData: {

        Records: [
          {
            "Context": {},
            "Message": {
              ...requestData
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Reset the websites in CDN  successfully')
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ],

        }
      }))
    });

  }

  const handleUpdateWebsite = async (data: any) => {
    await dispatch(websiteCards.resetAction({ actionType: 'update' }))
    await dispatch(websiteCards.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/add-new-cards-to-tenant-websites`, entity: 'websiteCards', jsonData: {

        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              PlatformWebSiteId: data?.PlatformWebSiteId,
              StoreId: data?.StoreId,
              DepartmentId: data?.DepartmentId
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Added New Cards to tenant websites from platform websites')
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ],

        }
      }))
    });
  }

  const handleCDNUpdateWebsite = async (data: any) => {
    await dispatch(websiteCards.resetAction({ actionType: 'create' }))
    await dispatch(websiteCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/update`, entity: 'websiteCards', jsonData: {

        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: data?.Id,
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Added New Cards from tenant websites and published in CDN')
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ],

        }
      }))
    });
  }
  const handleCDNResetWebsite = async (data: any) => {
    await dispatch(websiteCards.resetAction({ actionType: 'create' }))
    await dispatch(websiteCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/sync`, entity: 'websiteCards', jsonData: {

        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: data?.Id,
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Reset the tenant websites and published in CDN')
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ],

        }
      }))
    });
  }

  const handleCDNDeleteWebsite = async (data: any) => {
    await dispatch(websiteCards.resetAction({ actionType: 'create' }))
    await dispatch(websiteCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/remove`, entity: 'websiteCards', jsonData: {

        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: data?.Id,
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Delete the tenant Websites details from CDN')
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ],

        }
      }))
    });
  }
  const handleEnableTenantWebsite = async (data: any) => {
    await dispatch(websites.resetAction({ actionType: 'update' }))
    await dispatch(websites.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites`, entity: 'websites', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              ...data
            }
          }
        ]

      }
    }))
      .then(() => {

        // toast.info('Tenant Websites you are selected is activated now')
        dispatch(websites.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

            "PageNumber": pageData,
            "PageSize": 10,
            "SortField": "Id",
            "SortOrder": "desc",
            "Filters": [
              {
                "FieldName": "TenantId",
                "FilterOperatorId": 1,
                "FieldValue": tenantId,
                "FieldType": "number"
              }
            ],

          }
        }))
      });

  }

  const handleEnableSEOTenantWebsite = async (data: any) => {
    await dispatch(websiteCards.resetAction({ actionType: 'create' }))
    await dispatch(websiteCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/enable-seo-folder`, entity: 'websiteCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: data?.Id
            }
          }
        ]

      }
    })).then(() => {
      // toast.info('Tenant Websites you are selected is successfully published in CDN')
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ],

        }
      }))
    });

  }

  // Enable DBN Attributes
  const handleEnableDBNAttributesTenantWebsite = async (data: any) => {
    await dispatch(websiteCards.resetAction({ actionType: 'create' }))
    await dispatch(websiteCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/enable`, entity: 'websiteCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
            }
          }
        ]

      }
    })).then(() => {
      // toast.info('Tenant Websites you are selected is successfully published in CDN')
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ],

        }
      }))
    });

  }

  const handlePublishTenantWebsite = async (data: any) => {
    await dispatch(websiteCards.resetAction({ actionType: 'create' }))
    await dispatch(websiteCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/publish`, entity: 'websiteCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: data?.Id
            }
          }
        ]

      }
    }))
      .then(() => {
        // toast.info('Tenant Websites you are selected is successfully published in CDN')
        dispatch(websites.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

            "PageNumber": pageData,
            "PageSize": 10,
            "SortField": "Id",
            "SortOrder": "desc",
            "Filters": [
              {
                "FieldName": "TenantId",
                "FilterOperatorId": 1,
                "FieldValue": tenantId,
                "FieldType": "number"
              }
            ],

          }
        }))
      });

  }

  const handleSave = async (data: any) => {
    await dispatch(websites.resetAction({ actionType: 'update' }))
    await dispatch(websites.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites`, entity: 'websites', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              Id: data?.Id,
              TenantId: tenantId,
              PlatformWebSiteId: data?.PlatformWebSiteId,
              StoreId: data?.StoreId,
              DepartmentId: data?.DepartmentId,
              WebSiteName: data?.WebSiteName,
              WebSiteVersionId: data?.WebSiteVersionId,
              HostingUrl: updatedRowData?.HostingUrl || data?.HostingUrl,
              MappedDomain: updatedRowData?.MappedDomain || data?.MappedDomain,
              DisplayOrder: updatedRowData?.DisplayOrder || data?.DisplayOrder,
              FQDNName:updatedRowData?.FQDNName || data?.FQDNName,
              Remarks: data?.Remarks
            }
          }
        ]

      }
    }))
      .then(() => {
        // toast.info('Tenant Websites details are updated Successfully')
        dispatch(websites.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

            "PageNumber": pageData,
            "PageSize": 10,
            "SortField": "Id",
            "SortOrder": "desc",
            "Filters": [
              {
                "FieldName": "TenantId",
                "FilterOperatorId": 1,
                "FieldValue": tenantId,
                "FieldType": "number"
              }
            ],

          }
        }))
      });
    setUpdatedRowData({})
  }
  const handleDelete = (data: any) => {
    dispatch(websites.delete({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/delete`,
      entity: 'websites',
      jsonData: {
        Records: [
          {
            "Context": {},
            "Message": { Id: data?.Id }

          }
        ]
      }
    })).then(() => {
      // toast.info('Deleted websites successfully')
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ],

        }
      }))
    });
  }

  const fetchTenantWebsites = () => {
    dispatch(websites.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Filters": [
          {
            "FieldName": "TenantId",
            "FilterOperatorId": 1,
            "FieldValue": tenantId,
            "FieldType": "number"
          }
        ],

      }
    }))
  }
  useEffect(() => {
    createColumnDefs()
    fetchTenantWebsites()
  }, [pageData, pageSize])
  const handleAdd = () => {
    navigate(`${0}`)
  }
  const additionButtons: any = [
    {
      svg:
       <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
         <title>Add Website</title>
         <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
       </svg>,
     callback: () => handleAdd(),
   },
    {
      svg:
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
      <title>Reload</title>
      <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>,
    // name: 'Reload',
    callback: () => handleReloadData(),
    },
  ];

  return (
    <>
      {websitesItems?.isLoading ? <PageLoader />
        :
        <Table enableFilter={true}
        filterTypeLists={filterTypes}
        onSearch={handleSearch}columnData={columnDefs} rowData={websitesItems?.result?.items} setPageData={setPageData}
          handlereset={handlereset} handleEnableTenantWebsite={handleEnableTenantWebsite} handleInputChange={handleInputChange} handleUpdateTenantWebsite={handleUpdateWebsite} paginationData={websitesItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} headingName="Websites"
          handlePublishTenantWebsite={handlePublishTenantWebsite} additionButtons={additionButtons} IsWebsites={true} handleSave={handleSave}
          handleCDNUpdateWebsite={handleCDNUpdateWebsite} handleCDNReset={handleCDNResetWebsite}
          handleCDNDelete={handleCDNDeleteWebsite} setPageSize={setPageSize} handleEnableSEOTenantWebsite={handleEnableSEOTenantWebsite} handleEnableDBNAttributesTenantWebsite={handleEnableDBNAttributesTenantWebsite}/>
      }
    </>
  );
}

export default AgencyWebsites;
